import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import Date from '../Fields/Date/Date.js';
import { isDateOfBirth } from '../Util/validations.js';

const DateOfBirth = ({ required =false , name ='dateOfBirth' , validations , subHeading ,  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Date, {
        additionalScreenReaderLabel: getLabel('checkout.contact.dateofbirth'),
        tooltipText: getLabel('checkout.contact.dateofbirth.tooltip'),
        label: getLabel('checkout.contact.dateofbirth'),
        subHeading: subHeading,
        name: name,
        validations: [
            {
                validator: isDateOfBirth,
                errorMessage: getLabel('checkout.contact.error.invalidDate')
            },
            ...validations || [], 
        ],
        invalidDateErrorMessage: getLabel('checkout.contact.error.invalidDate'),
        required: required
    });
};

export { DateOfBirth };
//# sourceMappingURL=DateOfBirth.js.map
